/**
 * 事实包 API — F6（契约见 kickoff 02 §5）。
 *
 * GET /api/products/{product_id}/fact-packs  版本列表（按 finalized_at 倒序）
 * GET /api/fact-packs/{pack_id}              条目明细（按 role 裁剪：
 *                                            customer_viewer 过滤 internal 且不返回 authorization）
 *
 * 网站为只读镜像，提炼与会签在 geo-fact-pack skill 侧完成（FR1）。
 * 后端端点并行开发中；调用方必须自行 try/catch 做优雅降级（空态展示，不红屏）。
 */
import client from "./client";
import type { FactPack, FactPackDetail } from "../types";

/** 获取产品事实包版本列表（data.items 按 finalized_at 倒序）。 */
export async function getFactPacks(
  productId: string,
): Promise<{ items: FactPack[] }> {
  return client.get<unknown, { items: FactPack[] }>(
    `/products/${productId}/fact-packs`,
  );
}

/** 获取事实包条目明细。 */
export async function getFactPackDetail(packId: string): Promise<FactPackDetail> {
  return client.get<unknown, FactPackDetail>(`/fact-packs/${packId}`);
}
